export enum OfferTypeEnum {
    Offer = 1,
    Notice = 2
}

export const OfferTypeStringEnum = {
    Offer: 'Offer',
    Notice: 'Notice',
};
